"use client";

import { Icon } from "@iconify/react";
import { cn } from "cn";
import { Button, DropdownMenuTrigger, SidebarMenuButton } from "@/components/ui";
import { AuthUserAvatar } from "./AuthUserAvatar";
import {
  AUTH_NAVBAR_MENU_TRIGGER_CLASSES,
  AUTH_SIDEBAR_FOOTER_MENU_TRIGGER_CLASSES,
  AUTH_SIDEBAR_FOOTER_NAME_CLASSES,
  AUTH_SIDEBAR_FOOTER_SUBTITLE_CLASSES,
  AUTH_SIDEBAR_HEADER_MENU_TRIGGER_CLASSES,
} from "./styles";
import type { AuthMenuTriggerAs } from "./types";
import type { Session } from "next-auth";

export type AuthMenuTriggerProps = {
  triggerAs: AuthMenuTriggerAs;
  user: Session["user"];
  userDisplayName: string;
  sidebarSubtitle: string;
};

export const AuthMenuTrigger = ({
  triggerAs,
  user,
  userDisplayName,
  sidebarSubtitle,
}: AuthMenuTriggerProps) => (
  <DropdownMenuTrigger
    nativeButton={false}
    render={(props) => {
      if (triggerAs === "sidebar") {
        return (
          <SidebarMenuButton
            size="lg"
            className={AUTH_SIDEBAR_FOOTER_MENU_TRIGGER_CLASSES}
            {...props}
          >
            <span className="flex min-w-0 flex-1 items-center gap-3">
              <span className="min-w-0 flex-1 text-right">
                <span className={AUTH_SIDEBAR_FOOTER_NAME_CLASSES}>{userDisplayName}</span>
                <span className={AUTH_SIDEBAR_FOOTER_SUBTITLE_CLASSES}>{sidebarSubtitle}</span>
              </span>
              <AuthUserAvatar user={user} />
            </span>
            <Icon icon="lucide:chevron-up" className="ml-auto size-4 shrink-0" />
          </SidebarMenuButton>
        );
      }

      const isSidebarHeader = triggerAs === "sidebar-header";

      return (
        <Button
          variant="ghost"
          size="icon"
          className={cn(
            isSidebarHeader
              ? AUTH_SIDEBAR_HEADER_MENU_TRIGGER_CLASSES
              : AUTH_NAVBAR_MENU_TRIGGER_CLASSES,
          )}
          {...props}
        >
          <AuthUserAvatar user={user} />
        </Button>
      );
    }}
  />
);
